// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/.store/css-loader@3.6.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".box{display:flex;flex-wrap:wrap;width:400px}.box .item{border:1px solid #1241a8;white-space:nowrap;padding:0 10px;margin:5px;cursor:pointer;height:30px;display:flex;align-items:center;justify-content:center;font-size:12px}.box .item.on{color:#fff;background-color:#1241a8}", ""]);
// Exports
module.exports = exports;
